<template>
  <div>
    <AlertAuthError :error-message="errorText.message" :error-detail="errorText.detail" />
  </div>
</template>

<script>
import AlertAuthError from './AlertAuthError.vue';

export default {
  components: {
    AlertAuthError
  },

  data() {
    return {
      messageKey: {
        LASTNAME: {
          message: 'Cannot sign in with Google',
          detail: 'Please change your last name on Google account'
        }
      }
    };
  },
  computed: {
    errorText() {
      return this.messageKey['LASTNAME'] ?? { message: null, detail: null };
    }
  }
};
</script>

<style scoped></style>
